var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M6.336 2.57c-2.048.249-3.823 1.56-4.788 3.538-.723 1.48-.878 3.096-.442 4.612.253.88.733 1.726 1.383 2.435.242.264 8.776 8.003 8.973 8.137.183.125.36.171.603.159.39-.02.038.276 4.843-4.075a585 585 0 0 0 4.501-4.099 6.2 6.2 0 0 0 1.441-2.394 6.3 6.3 0 0 0 .2-2.915A6.97 6.97 0 0 0 21.616 4.8a9 9 0 0 0-1-.987q-1.16-.897-2.484-1.16c-1.47-.294-3.013.017-4.476.903-.47.283-.87.582-1.375 1.024l-.283.247-.185-.174a10 10 0 0 0-1.742-1.266 7 7 0 0 0-2.247-.784c-.294-.047-1.212-.067-1.488-.034",
  clipRule: "evenodd"
})));
export default SvgHeartFill;